<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Booker Tariff</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Incentives
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Incentives <span><i class="ic-promo"></i></span>
                  </h2>
                  <p>
                    Set all necessary parameters and configurations to support
                    your business.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Zone"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Incentive Name</th>
                  <th>Zone Name</th>
                  <th class="text-center">Group Zone</th>
                  <th class="text-left">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td :class="{ '--green35': item.isDefault }">
                    {{ item.isDefault ? "Default" : item.zoneInfo }}
                  </td>
                  <td class="text-center">
                    {{ item.isGroupZone ? "Yes" : "No" }}
                  </td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        @change="changeStatus(item)"
                        :disabled="!isAllowToUpdate"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="isAllowToDelete"
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="incentivemodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-sell" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Master Data Incentive</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <ul
                    class="nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"
                  >
                    <li :class="[activeTab === 'general' ? 'active' : '']">
                      <a
                        href="#incentive-general"
                        data-toggle="tab"
                        @click="activeTab = 'general'"
                      >
                        <span class="required">General</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'tiers' ? 'active' : '']">
                      <a
                        href="#incentive-tiers"
                        data-toggle="tab"
                        @click="activeTab = 'tiers'"
                      >
                        <span class="required">Tiers</span>
                      </a>
                    </li>
                  </ul>
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="tab-content">
                      <div
                        id="incentive-general"
                        class="tab-pane fade"
                        :class="[activeTab === 'general' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Name</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.name.$error,
                                }"
                                autocomplete="off"
                                v-model="model.name"
                              />
                              <div v-if="isSubmitted && $v.model.name.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.required"
                                  >Name is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.maxLength"
                                  >Name must be less than
                                  {{ $v.model.name.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  v-model="model.isDefault"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  Default Incentive
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="!model.isDefault">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  v-model="model.isGroupZone"
                                  @change="model.referenceZone = null"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  Group Zone
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="row" v-if="!model.isDefault">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Zone</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error':
                                    isSubmitted &&
                                    $v.model.referenceZone.$error,
                                }"
                                placeholder=""
                                label="text"
                                v-model="model.referenceZone"
                                :options="filteredZones"
                                :clearable="false"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.value"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted &&
                                  !$v.model.referenceZone.required
                                "
                                >Zone is required</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="incentive-tiers"
                        class="tab-pane fade"
                        :class="[activeTab === 'tiers' ? 'in active' : '']"
                      >
                        <div
                          class="row"
                          v-for="(item, index) in model.tiers"
                          :key="index"
                        >
                          <div class="col-sm-12">
                            <label>
                              {{
                                10 > item.order
                                  ? `Tier ${item.order}`
                                  : "Offline Tier"
                              }}
                            </label>
                          </div>
                          <div class="col-sm-12 mb-15">
                            <div class="row">
                              <div class="col-sm-6">
                                <v-select
                                  class="v-search-select"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.tiers.$each[index].type.$error,
                                  }"
                                  placeholder=""
                                  label="text"
                                  v-model="item.type"
                                  :options="tierTypes"
                                  :clearable="true"
                                  :searchable="true"
                                  :filterable="true"
                                  :reduce="(option) => option.value"
                                ></v-select>
                                <small
                                  class="form-text sts-danger"
                                  v-if="
                                    isSubmitted &&
                                    !$v.model.tiers.$each[index].type.required
                                  "
                                  >Type is required</small
                                >
                              </div>
                              <div class="col-sm-6">
                                <currency-input
                                  v-if="item.type === 'Fixed'"
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.tiers.$each[index].rate.$error,
                                  }"
                                  autocomplete="off"
                                  placeholder="Enter rate"
                                  v-model="item.rate"
                                  :allow-negative="false"
                                  :currency="{
                                    prefix: `${moneyFormat.currencyCode} `,
                                  }"
                                  :locale="moneyFormat.cultureCode"
                                  :precision="moneyFormat.numberOfDecimal"
                                />
                                <input
                                  v-else
                                  type="number"
                                  class="form-control"
                                  :class="{
                                    'field-error':
                                      isSubmitted &&
                                      $v.model.tiers.$each[index].rate.$error,
                                  }"
                                  v-model="item.rate"
                                  placeholder="Enter rate"
                                  step="any"
                                />
                                <div
                                  v-if="
                                    isSubmitted &&
                                    $v.model.tiers.$each[index].rate.$error
                                  "
                                >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.tiers.$each[index].rate.required
                                    "
                                    >Rate is required</small
                                  >
                                  <small
                                    class="form-text sts-danger"
                                    v-if="
                                      !$v.model.tiers.$each[index].rate.minValue
                                    "
                                    >Min rate is
                                    {{
                                      $v.model.tiers.$each[index].rate.$params
                                        .minValue.min
                                    }}</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, minValue, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import incentiveService from "@/services/master/incentive/incentiveService.js";
import zoneService from "@/services/master/zone/zoneService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
    filteredZones: function () {
      if (this.model) {
        if (this.model.isGroupZone) {
          const seen = new Set();
          return this.allZones
            .filter((item) => {
              const duplicate = seen.has(item.group);
              seen.add(item.group);
              return !duplicate;
            })
            .map((x) => {
              return { value: x.id, text: x.group };
            });
        } else {
          return this.allZones.map((x) => {
            return { value: x.id, text: x.name };
          });
        }
      }
      return [{ value: "", text: "" }];
    },
    validationRuleZone: function () {
      return !this.model.isDefault ? { required } : {};
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      activeTab: "general",
      formatter: null,
      moneyFormat: null,
      tierTypes: [],
      maxTiers: 10,
      allPermissions: [],
      allZones: [],
      itemToBeDeleted: null,
      items: [],
      model: {},
      isLoading: false,
      isUpdate: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        name: { required, maxLength: maxLength(150) },
        referenceZone: this.validationRuleZone,
        tiers: {
          $each: {
            type: { required },
            rate: { required, minValue: minValue(0) },
          },
        },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      this.getAllZones();
      this.tierTypes = [
        { value: "Percentage", text: "Percentage" },
        { value: "Fixed", text: "Fixed" },
      ];

      if (this.moneyFormat) {
        this.formatter = new Intl.NumberFormat(this.moneyFormat.cultureCode, {
          style: "currency",
          currency: this.moneyFormat.currencyCode,
          currencyDisplay: "code",
          minimumFractionDigits: this.moneyFormat.numberOfDecimal,
        });
      }
    }
  },
  mounted() {
    $(this.$refs.incentivemodal).on("hidden.bs.modal", this.closeModal);
  },
  updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-incentive-link");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.incentivemodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    closeModal() {
      this.resetValidations();
      this.model = {};
      $(this.$refs.incentivemodal).modal("hide");
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await incentiveService.getAll(filter);
        this.items = response.data.items;
        this.moneyFormat = response.data.moneyFormat;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async getAllZones() {
      this.allZones = await zoneService.getAllActive();
    },
    createItem() {
      this.isUpdate = false;
      this.activeTab = "general";
      let tiers = [];
      for (let i = 0; i < this.maxTiers; i++) {
        tiers.push({
          isOffline: false,
          order: i + 1,
          rate: 0,
          type: this.tierTypes[0].value,
        });
      }

      const newItem = {
        tiers: tiers,
        isDefault: true,
        isGroupZone: false,
        referenceZone: null,
      };

      this.openModal(newItem);
    },
    updateItem(item) {
      this.isUpdate = true;
      this.activeTab = "general";
      this.openModal(item);
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        // parse to number
        for (let i = 0; i < this.model.tiers.length; i++) {
          this.model.tiers[i].rate = parseFloat(this.model.tiers[i].rate);
        }
        if (this.isUpdate) {
          await incentiveService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await incentiveService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await incentiveService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await incentiveService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/sellingTariff/Incentive.vue